import { assertEvent, assign } from 'xstate';

import { createLogic as createControlActorLogic } from './actors/control/logic';
import { createLogic as createEditVariantALogic } from './actors/editVariantA/logic';
import { createLogic as createEditVariantBLogic } from './actors/editVariantB/logic';
import { machine } from './orchestrationMachine';

export const createLogic = () =>
	machine.provide({
		actors: {
			controlActorSrc: createControlActorLogic(),
			editVariantAActorSrc: createEditVariantALogic(),
			editVariantBActorSrc: createEditVariantBLogic(), // edit variant B uses the same logic as edit variant A
		},
		guards: {
			isEditVariantA: ({ context }) => context.draft?.metadata?.variant === 'preview_edit_variant_a',
			isEditVariantB: ({ context }) => context.draft?.metadata?.variant === 'preview_edit_variant_b',
		},
		actions: {
			syncDraft: assign({
				draft: ({ event }) => {
					assertEvent(event, 'sync_draft');
					return event.draft;
				},
			}),
		},
	});
